/**
 * Ушедшие клиенты
 * @return Promise
 */
const statGoneList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/gone/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Ушедшие клиенты. Кол-во строк.
 * @return Promise
 */
const statGoneListCnt = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/gone/getListCnt",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Ушедшие клиенты. Данные для графика
 * @return Promise
 */
const statGoneChartData = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/gone/getChartData",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { statGoneList, statGoneListCnt, statGoneChartData };
